import { Component, OnInit, Input } from '@angular/core';
import { CustomerService } from 'src/app/services/api/customer.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SessionService } from 'src/app/services/session.service';
import { AddressService } from 'src/app/services/api/address.service';
import { MapService } from 'src/app/services/map.service';
import { LangService } from 'src/app/services/lang/lang.service';
import { ConfirmationmodalComponent } from 'src/app/components/modals/confirmationmodal/confirmationmodal.component';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { DebounceService } from 'src/app/services/debounce.service';
import { SocketioService } from 'src/app/services/socketio.service';

@Component({
  selector: 'app-addresses-and-form-field',
  templateUrl: './addresses-and-form-field.component.html',
  styleUrls: ['./addresses-and-form-field.component.scss']
})
export class AddressesAndFormFieldComponent implements OnInit {

	@Input() isInCheckoutPage:boolean = false;
	@Input() closeBtnLabel:string = 'Close';
	@Input() setAsDefaultAddressCallback:any = null;
	@Input() isInChangeOrderrequest:boolean = false;

	private modalRef : BsModalRef;

	numberPattern = /^([0-9]+$)/

	address_form: FormGroup;
	showAddressForm: boolean = false;
	editAddressId:any = null;

	selectedCity:any = null;
	cityName:string = '';

	selectedStreet:any = null;
	selectedStreetName:any = null;

	streetTypeAfter:any = null;

	showAutoCompleteBox:boolean = false;
	addressAutoComplete:any = null;
	
	mapZoom: any = 11;

	constructor(
		public customerService: CustomerService,
		public formBuilder: FormBuilder,
		public sessionService: SessionService,
		public addressService: AddressService,
		public mapService: MapService,
		public lang: LangService,
		public modalService: BsModalService,
		public debounceService: DebounceService,
		public socketioService: SocketioService
	) {
		this.streetTypeAfter = debounceService.debounce(f => {
			let jsonData = {
				base_url: "https://maps.googleapis.com/maps/api/place/autocomplete/json",
				method: "GET",
				params: {
					"input": this.address_form.value.street+", "+this.selectedStreetName+", "+this.cityName+", "+this.address_form.value.region,
					"region": "PH",
					"key": this.mapService.key
				}
			};
			this.socketioService.socket.emit('http_request', jsonData, (data) => {
				this.addressAutoComplete = data.predictions;
				if(!this.showAutoCompleteBox){
					this.showAutoCompleteBox = true;
					let handler = () => {
						this.showAutoCompleteBox = false;
						document.removeEventListener('click', handler);
					}
					document.addEventListener("click", handler);
				}
			});
		}, 300);
	}

	ngOnInit(): void {
		this.address_form = this.formBuilder.group({
			firstname: ['', [Validators.required]],
			lastname: ['', [Validators.required]],
			company: [''],
			region_id:['', [Validators.required]],
			region:'',
			postcode:'',
			street_id:['', [Validators.required]],
			street:['', [Validators.required]],
			city:['', [Validators.required]],
			telephone:['', [Validators.required, Validators.pattern(this.numberPattern), Validators.minLength(11), Validators.maxLength(11)]],
			country_id:'PH',
			email:'',
			same_as_billing: 1,
			save_in_address_book: 1,
			customer_id:''
		});

		if(!this.sessionService.user.isLogedIn){
			/**
			 * TODO: open the login modal form field
			 */
		} 
		else {
			if(!this.isInChangeOrderrequest){
				this.getLogedInCustomer();
			}
			this.addressService.getProvince('PH').then(res => {
			});
		}

		this.socketCallBack();
	}

	resetAddressForm(){
		this.address_form.reset();
		let val = {
			firstname: this.customerService.customer.firstname,
			lastname: this.customerService.customer.lastname,
			customer_id: this.customerService.customer.id,
			email: this.customerService.customer.email,
			same_as_billing: 1,
			save_in_address_book: 1,
			country_id:"PH",
			region_id: '',
			street_id: '',
			city: ''
		}
		this.address_form.patchValue(val);
		
		this.cityName = '';
		this.selectedCity = null;
		this.selectedStreet = null;
		this.selectedStreetName = null;
		this.showAutoCompleteBox = false;
		this.addressAutoComplete = null;
	}

	socketCallBack(){
		this.socketioService.addCallback('address_save', 'address_book_page', (data:any) => {
			if(data.socket_id != this.socketioService.socket.id){
				this.getLogedInCustomer();
			}
		});
		this.socketioService.addCallback('checkout_delete_address', 'address_book_page', (data:any) => {
			if(data.socket_id != this.socketioService.socket.id){
				this.customerService.removeAddressToList(data.data);
			}
		});
		this.socketioService.addCallback('change_default_address', 'address_book_page', (data:any) => {
			if(data.socket_id != this.socketioService.socket.id){
				this.customerService.setAsDefaultAddress(data.data, false);
			}
		});
	}

	ngOnDestroy(){
		this.socketioService.removeCallback('address_save', 'address_book_page');
		this.socketioService.removeCallback('checkout_delete_address', 'address_book_page');
		this.socketioService.removeCallback('change_default_address', 'address_book_page');
		this.setAsDefaultAddressCallback = null;
	}

	showConfirmation(address){
		const initialState = {
			title: 'Delete Address?',
			message : '',
		}

		this.modalRef = this.modalService.show(ConfirmationmodalComponent, {initialState});
		this.modalRef.setClass('modal-dialog-centered modal-confimation');

		this.modalRef.content.onClose = () => {
			this.modalRef.hide();
		};

		this.modalRef.content.onConfirm = () => {
			this.modalRef.hide();
			this.deleteAddress(address);
		};
	}

	/**
	 * delete address
	 */
	deleteAddress(address){
		this.customerService.deleteAddress(address, this.socketioService).then(isDeleted => {
			if(isDeleted){
				setTimeout(f => {
					this.getLocationByDefaultAdd();
				},500);
			}
		});
	}

	/**
	 * display the customer address form
	 */
	showAddresForm(){
		this.resetAddressForm();
		this.showAddressForm = true;
		this.editAddressId = null;
	}

	get streets(){
		let s:any = null;
		if(this.addressService.streets && this.selectedCity){
			if(typeof this.addressService.streets[this.selectedCity.region_code] != 'undefined'){
				if(typeof this.addressService.streets[this.selectedCity.region_code][this.selectedCity.city_code] != 'undefined'){
					s =  this.addressService.streets[this.selectedCity.region_code][this.selectedCity.city_code];
				}
			}
		}
		return s;
	}

	setStreet(){
		let value = this.address_form.controls.street_id.value;
		if(this.streets){
			this.streets.forEach(street => {
				if(value == street.value){
					this.selectedStreet = street;
					this.selectedStreetName = street.label;
					this.getLocation();
				}
			});
		}
	}

	setCity(){
		let inputCity = this.address_form.controls.city.value;
		let cities = this.addressService.cities[this.address_form.controls.region_id.value];
		cities.forEach(city => {
			if(inputCity == city.value){

				this.selectedStreet = null;
				this.selectedStreetName = null;
				this.address_form.controls.street_id.reset();
				this.address_form.controls.street_id.patchValue('');

				this.cityName = city.label;
				this.selectedCity = city;

				this.addressService.getStreet(city.region_code, city.city_code);
				this.getLocation();
				return this.cityName;
			}
		});
	}
	
	/**
	 * set the provinces in PH
	 * this is for the select field of provinces/regions
	 * trigerred on changed of the select
	 */
	setProvince(){
		let prov: any = this.addressService.provinces[this.address_form.value.country_id];
		prov.forEach(province => {
			if(province.value == this.address_form.value.region_id){

				this.cityName = '';
				this.selectedCity = null;
				this.selectedStreet = null;
				this.selectedStreetName = null;
				this.address_form.controls.city.reset();
				this.address_form.controls.city.patchValue('');

				this.address_form.controls.street_id.reset();
				this.address_form.controls.street_id.patchValue('');

				this.address_form.controls.region.patchValue(province.label);
				this.address_form.controls.region_id.patchValue(province.value);
				this.getCity(province.value);
				this.getLocation();
			}
		});
	}

	/**
	 * set the city based on the selected province/region ID
	 * @param provinceId
	 */
	getCity(provinceId){
		this.address_form.controls.city.patchValue('');
		return this.addressService.getCity('PH', provinceId);
	}

	async getLogedInCustomer(){
		this.mapService.coords.lat = 0;
		this.mapService.coords.lng = 0;
		await this.customerService.getLogedInCustomer().then(customer => {
			if(this.customerService.customer.addresses.length){
				let df = parseInt(this.customerService.customer.default_shipping);
				this.getAddressLatLng(df);
			}
			else {
				this.showAddresForm();
			}
		});
	}

	getLocationByDefaultAdd(){
		this.customerService.customer.addresses.forEach(add => {
			if(add.default_shipping){
				this.getAddressLatLng(add.id);
			}
		});
	}

	/**
	 * get the details of the google maps auto complete result
	 * then set map coordinates
	 * 
	 * @param isSetmapCoord boolean
	 */
	getGoogleMapsAutocompleteAddressDetails(prediction, isSetmapCoord:boolean = true){
		let jsonData = {
			base_url: "https://maps.googleapis.com/maps/api/place/details/json",
			method: "GET",
			params: {
				"place_id": prediction.place_id,
				"key": this.mapService.key
			}
		};

		this.address_form.controls.street.patchValue(prediction.description);

		this.socketioService.socket.emit('http_request', jsonData, (data) => {
			let loc = data.result.geometry.location;
			this.setMapCoordinate(loc.lat, loc.lng);
			this.closeAutoCompleteBox();
		});
	}

	closeAutoCompleteBox(){
		this.showAutoCompleteBox = false;
		this.addressAutoComplete = null;
	}

	setMapCoordinate(lat, lng){
		this.mapService.coords.lat = lat;
		this.mapService.coords.lng = lng;
		this.mapZoom = 18;
	}

	/**
	 * get the geographical location from address
	 */
	getLocation(a:any = null) {
		let address = {
			// street: [this.address_form.value.street],
			street: [this.selectedStreetName],
			city: this.cityName,
			region: this.address_form.value.region
		}

		if(a){
			address = a;
		}
		if(address.street[0] != '' && address.city != '' && address.region != '') {
			this.mapService.geoCode(address).subscribe(result => {
				this.mapService.coords.lat = result['results'][0]['geometry']['location']['lat'];
				this.mapService.coords.lng = result['results'][0]['geometry']['location']['lng'];
			});
		}
	}

	getAddressLatLng(id) {
		let url = this.customerService.getStoreUrl('/V1/lns-api/customer/address/latlng/'+id);
		this.customerService.makeRequest(url, null, 'GET', false).then(address => {
			if(address[0]['lat'] != null && address[0]['lng'] != null) {
				this.mapService.coords.lat = parseFloat(address[0]['lat']);
				this.mapService.coords.lng = parseFloat(address[0]['lng']);
			} else {
				this.getLocation({
					city: address[0]['city'],
					region: address[0]['region'],
					street: [address[0]['street']]
				});
			}
		});
	}

	hasErrors(field:string){
		return this.address_form.controls[field].errors && (this.address_form.controls[field].dirty || this.address_form.controls[field].touched);
	}

	// isNumberKey(evt) {
	// 	evt = (evt) ? evt : window.event;
	// 	var charCode = (evt.which) ? evt.which : evt.keyCode;
	// 	if (charCode > 31 && (charCode < 48 || charCode > 57)) {
	// 		return false;
	// 	}
	// 	return true;
	// }


	saveAddress(){
		this.address_form.markAllAsTouched(); 

		if(this.address_form.status == 'VALID'){
			/* Replace (") with (') to avoid problem with the backend queries */
			let replace = /"/gi;
			let streetStrToReplace = this.address_form.value.street.replace(replace, "");
			streetStrToReplace += ', ' + this.selectedStreetName;

			if(this.mapService.checkIfValidlatitudeAndlongitude(this.mapService.coords.lat + ',' + this.mapService.coords.lng)){
				let jsonData = {
					"region": this.address_form.value.region,
					"region_id": this.address_form.value.region_id,
					"region_code":"",
					"country_id":"PH",
					"street":[
						streetStrToReplace
					],
					"city": this.cityName,
					"firstname": this.address_form.value.firstname,
					"lastname": this.address_form.value.lastname,
					"customer_id": this.address_form.value.customer_id,
					"email": this.address_form.value.email,
					"telephone":  this.address_form.value.telephone,
					"same_as_billing":1,
					"save_in_address_book":1,
					"lat": this.mapService.coords.lat,
					"lng": this.mapService.coords.lng
				}
		
				if(this.address_form.value.company){
					jsonData['company'] = this.address_form.value.company;
				}
		
				let url = this.customerService.getStoreUrl('/V1/lns-api/customer/address/me');
				if(this.editAddressId) {
					url += '/'+this.editAddressId;
				}
				this.customerService.setLoader(true);
				this.customerService.makeRequest(url, jsonData, 'POST').then(async address => {
					await this.getLogedInCustomer();
					this.customerService.toastService.add('Address successfully saved', 'success');
					this.mapService.coords.lat = null;
					this.mapService.coords.lng = null;
					this.editAddressId = null;
					this.showAddressForm = false;
					this.customerService.setLoader(false);

					const defaultShipping = this.customerService.customer.addresses.filter(
						(address: any) => address.id == this.customerService.customer.default_shipping
					)[0];
					
					// simulate address click after saving new address
					this.setAsDefaultAddress(defaultShipping);

					this.socketioService.emitToSelf('address_save', address);
				});
			}
			else {
				this.getLocation();
				this.customerService.toastService.add('Invalid longitude or latitude.', 'danger');
				this.customerService.toastService.add('Please make sure you type your longitude and latitude correctly, or just pin your location using Google Maps to get longitude and latitude.', 'danger');
			}
		}
	}

	cancelAddAddress(){
		this.resetAddressForm();
		this.showAddressForm = false;
		if(!this.isInCheckoutPage){
			this.getLogedInCustomer();
		}
	}

	setAsDefaultAddress(address:any, isMakeRequest:boolean=true){
		this.getAddressLatLng(address.id);
		if(!this.isInCheckoutPage){
			this.socketioService.emitToSelf('change_default_address', address);
			this.customerService.setAsDefaultAddress(address, isMakeRequest);
		}
		else {
			// this.customerService.setAsDefaultAddress(address, false);
			// this.socketioService.emitToSelf('selected_address_change', address);
		}

		if(typeof this.setAsDefaultAddressCallback == 'function'){
			this.setAsDefaultAddressCallback(address);
			if(this.isInCheckoutPage){
				this.customerService.setAsDefaultAddress(address, false);
			}
		}
	}
}
